import { Navigate } from 'react-router-dom';

import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';

const UserCenterLayout = withLazyLoading(() =>
  import('../../modules/user-center/components/layout/UserCenterLayout').then((m) => ({
    default: m.UserCenterLayout,
  })),
);

const PeopleDirectory = withLazyLoading(() =>
  import('../../modules/user-center/components/people/PeopleDirectory').then((m) => ({
    default: m.PeopleDirectory,
  })),
);

const PersonSettingsRoute = withLazyLoading(() =>
  import('../../modules/user-center/components/person/PersonSettingsRoute').then((m) => ({
    default: m.PersonSettingsRoute,
  })),
);

const RolesLibrary = withLazyLoading(() =>
  import('../../modules/user-center/components/library/RolesLibrary').then((m) => ({
    default: m.RolesLibrary,
  })),
);

const PlantsLicences = withLazyLoading(() =>
  import('../../modules/user-center/components/plants/PlantsLicences').then((m) => ({
    default: m.PlantsLicences,
  })),
);

const PlantPeopleRoute = withLazyLoading(() =>
  import('../../modules/user-center/components/plants/PlantPeopleRoute').then((m) => ({
    default: m.PlantPeopleRoute,
  })),
);

const userCenterRoutes = [
  {
    path: '/user-center',
    handle: createCrumbHandle('User Center'),
    element: <UserCenterLayout />,
    children: [
      { index: true, element: <Navigate to="people" replace /> },
      {
        path: 'people',
        handle: createCrumbHandle('People'),
        element: <PeopleDirectory />,
      },
      {
        path: 'people/:userId',
        handle: createCrumbHandle('Person'),
        element: <PersonSettingsRoute />,
      },
      {
        path: 'library',
        handle: createCrumbHandle('Roles & grants'),
        element: <RolesLibrary />,
      },
      {
        path: 'plants',
        handle: createCrumbHandle('Plants & modules'),
        element: <PlantsLicences />,
      },
      {
        path: 'plants/:plantId/people',
        handle: createCrumbHandle('People'),
        element: <PlantPeopleRoute />,
      },
    ],
  },
];

export default userCenterRoutes;
